import { Graph } from 'src/generated/graph';
export default class ProductListArrangement {
  protected left: Graph.ProductRawJson[] = [];
  protected right: Graph.ProductRawJson[] = [];
  protected leftHeight = 0;
  protected rightHeight = 0;
  protected pointer = 0;
  protected previousData: Graph.ProductRawJson[] = [];

  update(data: Graph.ProductRawJson[]) {
    if (data && this.pointer < data.length) {
      this.arrange(data, this.pointer);
      this.previousData = data;
    } else if (data.length === this.pointer || data.length < this.pointer) {
      if (data !== this.previousData) {
        this.left = [];
        this.right = [];
        this.leftHeight = 0;
        this.rightHeight = 0;
        this.arrange(data, 0);
      }
    }
  }

  protected getHeight(item: Graph.ProductRawJson) {
    return item.is_square_picture ? 350 : 490;
  }

  protected arrange(data: Graph.ProductRawJson[], start: number) {
    for (let i = start; i < data.length; i++) {
      const currentItem = data[i];

      if (this.leftHeight > this.rightHeight) {
        this.right.push(currentItem);
        this.rightHeight += this.getHeight(currentItem);
      } else {
        this.left.push(currentItem);
        this.leftHeight += this.getHeight(currentItem);
      }
    }

    this.pointer = data.length;
  }

  getLeftSide(): Graph.ProductRawJson[] {
    return this.left;
  }

  getRightSide(): Graph.ProductRawJson[] {
    return this.right;
  }
}
